import {filterFileListByApprovedExtension} from '@spout/any-shared/models';
import {getFileName, uuid} from '@spout/web-global/fns';
import {FileWithId} from './import-files.models';

export function createFilesWithId(files: File[]): FileWithId[] {
  return filterFileListByApprovedExtension(files).map((file: File) => {
    return {
      file,
      id: uuid(),
      // name: getFileName(file.name).split(' ').join('_'),
      name: getFileName(file.name)
    };
  });
}
